import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Nav from './components/Nav';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import DailyLog from './pages/DailyLog';
import ProductScan from './pages/ProductScan';
import History from './pages/History';
import Swap from './pages/Swap';
import { getProfile } from './utils/storage';
import './App.css';

function App() {
  const [hasProfile, setHasProfile] = useState(!!getProfile());

  if (!hasProfile) {
    return <Onboarding onComplete={() => setHasProfile(true)} />;
  }

  return (
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<ProductScan />} />
          <Route path="/log" element={<DailyLog />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/history" element={<History />} />
          <Route path="/swap" element={<Swap />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Nav />
      </div>
    </Router>
  );
}

export default App;
